import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routesPath } from '@/utils/routesPath.js';
import DefaultLayout from '@/components/Shared/Layout.js';
import RequireAuth from '@/app/RequireAuth.js';

import {
    Login,
    Profile,
    SignUp,
    Teachers,
    Students,
    Courses,
    CoursesStudent,
    Programs,
    Staff,
    ActiveAccount,
    ForgotPassword
} from '@/pages';

import NotFound from '@/components/Authentication/404.js';
import Tokens from '@/components/Tokens/Tokens.js';
import Calendar from '@/components/Calendar/Calendar.js';
import { useSelector } from 'react-redux';

const protectedRoutes = [
    // Common
    { path: `${routesPath.COMMON.HOME}`, element: <Calendar /> },
    { path: `${routesPath.COMMON.DASHBOARD}`, element: <Calendar /> },

    //Page
    { path: `${routesPath.TEACHERS}`, element: <Teachers /> },
    { path: `${routesPath.STUDENTS}`, element: <Students /> },
    { path: `${routesPath.PROFILE}`, element: <Profile /> },
    { path: `${routesPath.COURSES_ADMIN}`, element: <Courses /> },
    { path: `${routesPath.COURSES_STUDENT}`, element: <CoursesStudent /> },
    { path: `${routesPath.PROGRAMS}`, element: <Programs /> },
    { path: `${routesPath.STAFF}`, element: <Staff /> },
    { path: `${routesPath.TOKENS}`, element: <Tokens /> },
    { path: `${routesPath.EVENTS}`, element: <Calendar /> }
];

const RootLayout = () => {
    const authData = useSelector((state) => state.auth);

    return (
        <RequireAuth>
            <DefaultLayout roles={authData?.roles} />
        </RequireAuth>
    );
};

const router = createBrowserRouter([
    // Page Routes
    {
        path: routesPath.DEFAULT,
        element: <RootLayout />, // Use the wrapper component here
        id: 'root',
        children: protectedRoutes // No need to map here if the format is already correct
    },
    // Auth Routes
    { path: `${routesPath.AUTH.LOGIN}`, element: <Login /> },
    { path: `${routesPath.AUTH.REGISTER}`, element: <SignUp /> },
    { path: `${routesPath.AUTH.FORGOTPASSWORD}`, element: <ForgotPassword /> },
    { path: `${routesPath.AUTH.ACTIVE_ACCOUNT}`, element: <ActiveAccount /> },

    // Unmatched Routes
    { path: routesPath.COMMON.ERROR, element: <NotFound /> }
]);

const AppRouting = () => {
    return <RouterProvider router={router} />;
};

export default AppRouting;
